import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * /guide — full-viewport admin user guide.
 *
 * Fetches the pre-rendered HTML from GET /admin/guide (behind the
 * standard admin auth) and renders it inside an iframe via `srcDoc`.
 * srcDoc keeps the guide's own CSS/JS isolated from the admin shell
 * (no style bleed either way) while still letting the guide's internal
 * TOC anchors, scrollspy and print styles work exactly as they do when
 * the HTML is opened directly.
 *
 * The admin layout (header + sidebar) is suppressed for this route in
 * App.tsx so the iframe fills the whole tab.
 */
import React, { useCallback, useEffect, useState } from 'react';
import { Button, Spin, Typography } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { getAdminGuide } from '../api';
const { Title, Text } = Typography;
export default function GuideScreen() {
    const [state, setState] = useState({ kind: 'loading' });
    const load = useCallback(async () => {
        setState({ kind: 'loading' });
        try {
            const html = await getAdminGuide();
            setState({ kind: 'ready', html });
        }
        catch (err) {
            const message = err.message || 'שגיאה בטעינת המדריך';
            setState({ kind: 'error', message });
        }
    }, []);
    useEffect(() => { void load(); }, [load]);
    if (state.kind === 'loading') {
        return (_jsx("div", { style: {
                position: 'fixed', inset: 0,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                background: '#FAF7FD',
            }, children: _jsx(Spin, { size: "large" }) }));
    }
    if (state.kind === 'error') {
        return (_jsxs("div", { dir: "rtl", style: {
                position: 'fixed', inset: 0,
                display: 'flex', flexDirection: 'column',
                alignItems: 'center', justifyContent: 'center',
                gap: 16, padding: 24, background: '#FAF7FD', textAlign: 'center',
            }, children: [_jsx(Title, { level: 3, style: { margin: 0, color: '#22174B' }, children: "\u05E9\u05D2\u05D9\u05D0\u05D4 \u05D1\u05D8\u05E2\u05D9\u05E0\u05EA \u05D4\u05DE\u05D3\u05E8\u05D9\u05DA" }), _jsx(Text, { type: "secondary", style: { maxWidth: 480 }, children: state.message }), _jsx(Button, { type: "primary", icon: _jsx(ReloadOutlined, {}), onClick: () => void load(), children: "\u05E0\u05E1\u05D4 \u05E9\u05D5\u05D1" })] }));
    }
    return (_jsx("iframe", { title: "\u05DE\u05D3\u05E8\u05D9\u05DA \u05DC\u05DE\u05E0\u05D4\u05DC", srcDoc: state.html, style: {
            position: 'fixed',
            inset: 0,
            width: '100vw',
            height: '100vh',
            border: 'none',
            background: '#FAF7FD',
        } }));
}
